module.exports = __webpack_public_path__ + "img/soccer-icon.1db77315.png";